<template>
  <b-container>
    <b-row>
      <b-col>
        <br />
        <router-link :to="{ name: 'AssignmentTermsList', params: {vendorId: this.vendorId, productId: this.productId}}">
          Back to AssignmentTerms
        </router-link>
        <h2> Options for the AssignmentTerm #{{ id }} </h2>
        <p><ErrorsContainer :errors="errors" /></p>
        <b-alert variant="success"
           dismissible
           fade
           :show="showSuccessfulUpdateMessage"
           @dismissed="showSuccessfulUpdateMessage=false">
           Options were successfully updated. The buying probability will be recalculated.
        </b-alert>

        <h6> Language: {{questionsWithAnswers.language}} </h6>
        <b-form class='options-form' @submit="onSubmit">
          <b-tabs>
            <b-tab title="Beratung" active>
              <div v-for="question in questionsWithAnswers.beratung_questions" class="question" :key="question.id">
                <b-form-group>
                  <p class='question-label'>{{question.label}}</p>
                  <b-form-checkbox-group stacked v-model="question.checked_answers">
                    <b-form-checkbox v-for='answer in question.answers' v-bind:value='answer.value' :key="answer.id">
                      {{answer.text}}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <hr />
              </div>
            </b-tab>
            <b-tab title="Phoenix">
              <b-alert variant="warning" show>
                These are Phoenix options. The questions are answered by the customer and they are not visible for the callcenter agents.
                Please be CAUTION, if you change them, it might exclude vendors from some product requests.
              </b-alert>

              <div v-for="question in questionsWithAnswers.phoenix_questions" class="question" :key="question.id">
                <b-form-group>
                  <p class='question-label'>{{question.label}}</p>
                  <b-form-checkbox-group stacked v-model="question.checked_answers">
                    <b-form-checkbox v-for='answer in question.answers' v-bind:value='answer.value' :key="answer.id">
                      {{answer.text}}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
                <hr />
              </div>
            </b-tab>
          </b-tabs>
          <b-button type="submit" variant="success">Submit</b-button>
          <b-button @click="$router.go(-1)" variant="outline-secondary">Cancel</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import AssignmentTermOptionsProvider from '@/services/AssignmentTermOptionsProvider'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'AssignmentTermOptions',
  data () {
    return {
      id: this.$route.params.id,
      vendorId: this.$route.params.vendorId,
      productId: this.$route.params.productId,
      questionsWithAnswers: {},
      errors: [],
      showSuccessfulUpdateMessage: false
    }
  },

  components: {
    ErrorsContainer
  },

  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.errors = []

      return new Promise((resolve, reject) => {
        AssignmentTermOptionsProvider.update(this.id, this.optionsToUpdate())
          .then((resp) => {
            this.questionsWithAnswers = resp.body.questions
            this.showSuccessfulUpdateMessage = true
            resolve(resp)
          }, (resp) => {
            this.errors = resp.body.errors
            resolve(resp)
          })
          .finally(() => {
            this.$scrollTo('html')
          })
      })
    },

    optionsToUpdate () {
      let allAnswers = []
      let checkedAnswers = []

      for (let question of this.questionsWithAnswers.beratung_questions) {
        checkedAnswers = checkedAnswers.concat(question.checked_answers)
        for (let answer of question.answers) {
          allAnswers.push(answer.value)
        }
      }

      for (let question of this.questionsWithAnswers.phoenix_questions) {
        checkedAnswers = checkedAnswers.concat(question.checked_answers)
        for (let answer of question.answers) {
          allAnswers.push(answer.value)
        }
      }

      return allAnswers.filter(uuid => !checkedAnswers.includes(uuid))
    }
  },

  mounted () {
    AssignmentTermOptionsProvider.edit(this.id)
      .then((resp) => {
        this.questionsWithAnswers = resp.body.questions
      })
  }
}

</script>

<style scoped>
  .question {
    margin-top: 25px;
  }

  .options-form {
    margin-bottom: 15px;
  }

  .question-label {
    font-weight: bold;
  }
</style>
